var map = {
	"./horoscope-icon-0.png": 1524,
	"./horoscope-icon-1.png": 1525,
	"./horoscope-icon-10.png": 1526,
	"./horoscope-icon-11.png": 1527,
	"./horoscope-icon-2.png": 1528,
	"./horoscope-icon-3.png": 1529,
	"./horoscope-icon-4.png": 1530,
	"./horoscope-icon-5.png": 1531,
	"./horoscope-icon-6.png": 1532,
	"./horoscope-icon-7.png": 1533,
	"./horoscope-icon-8.png": 1534,
	"./horoscope-icon-9.png": 1535,
	"./horoscope-icon-white-0.png": 188,
	"./horoscope-icon-white-1.png": 189,
	"./horoscope-icon-white-10.png": 190,
	"./horoscope-icon-white-11.png": 191,
	"./horoscope-icon-white-2.png": 192,
	"./horoscope-icon-white-3.png": 193,
	"./horoscope-icon-white-4.png": 194,
	"./horoscope-icon-white-5.png": 195,
	"./horoscope-icon-white-6.png": 196,
	"./horoscope-icon-white-7.png": 197,
	"./horoscope-icon-white-8.png": 198,
	"./horoscope-icon-white-9.png": 199
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1523;


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes ^\.\/horoscope\-icon\-.*\.png$
// module id = 1523
// module chunks = 0